<script>
import { mapActions, mapGetters } from "vuex";
import { requiredIf } from "vuelidate/lib/validators";
import journeyService from "@/services/journey";

export default {
  name: "ChangeJourney",
  validations: {
    currentJourney: {
      required: requiredIf(function () {
        return this.inherit ? false : true;
      }),
    },
    inherit: {},
  },
  data() {
    return {
      inherit: false,
      currentJourney: "",
      site: null,
      area: null,
      submitted: false,
      action: null,
      journeys: [],
      parentAreaJourneyId: null,
      modal_id: null,
      journey: null,
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo", "getModalState"]),
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("changeJourney_");
    },
  },
  methods: {
    ...mapActions("journey", ["fetchJourneyNormalList"]),
    async onSubmit() {
      this.submitted = true;
      if (!this.inherit && !this.currentJourney) return;
      this.$emit(
        "changeKioskJourney",
        {
          kiosk_id: this.getModalInfo.id,
          journey_id: this.inherit
            ? this.parentAreaJourneyId
            : this.currentJourney.id,
          area_id: this.getModalInfo.area_id,
        },
        this.modal_id
      );
    },
  },
  async beforeMount() {
    this.journey = this.getModalInfo.journey;
    this.parentAreaJourneyId = this.getModalInfo.parentAreaJourneyId;
    this.modal_id = this.getModalInfo.modalId;

    this.currentJourney = this.journey;
    if (this.journey.id == this.parentAreaJourneyId) this.inherit = true;

    const { data: siteJourneysData } = await journeyService.getJourneysNormal(
      this.getModalInfo.site_id
    );
    this.journeys = siteJourneysData;

    siteJourneysData.forEach((item) => {
      if (item.id == this.getModalInfo.journey_id) {
        this.currentJourney = { id: item.id, name: item.name };
      }
    });
  },
};
</script>

<template>
  <div>
    <h4 class="allareakiosk-header">{{ $t("sitesAndDevices.changeJourney") }}</h4>
    <b-form-group class="users-notification">
      <b-form-checkbox
        name="check-button"
        :disabled="submitted"
        v-model="$v.inherit.$model"
        >{{ $t("sitesAndDevices.inheritJourney")}}
        </b-form-checkbox
      >
    </b-form-group>

    <div class="form-groups multi-inputs" v-if="!inherit">
      <!-- journey  -->
      <b-form-group style="margin-top: 16px">
        <vp-multiselect
          id="jourey"
          v-model="$v.currentJourney.$model"
          title="Journey"
          :options="journeys"
          :show-labels="false"
          label="name"
          :allowEmpty="true"
          :showPlaceholderIcon="true"
          :disabled="submitted"
        />
      </b-form-group>
    </div>
    <div class="actionsline-inside"></div>
    <!-- action btns  -->
    <div class="actions-btns">
      <button
        class="submit-btn btn btn-primary add-submit"
        size="md"
        @click="onSubmit"
        :disabled="submitted || $v.$invalid || !$v.$anyDirty"
      >
        <i
          v-if="submitted"
          class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
        ></i>
        {{ $t("common.change") }}
      </button>
      <button
        :disabled="submitted"
        :class="{ 'cursor-stop': submitted }"
        class="btn btn-outline-danger cancel-reject"
        @click="$bvModal.hide(modal_id)"
      >
        {{ $t("common.cancel") }}
      </button>
    </div>
  </div>
</template>

<style lang="scss">
div[id*="changeJourney"] {
  div[class*="modal-content"] {
    position: absolute;
    border-radius: 26px;
    float: inline-start;
    inset-inline-start: 50%;
    top: 50%;
    transform: translate(-50%, 30%);
    width: 579px !important;
    .cursor-stop {
      cursor: not-allowed;
    }
    div[class*="modal-body"] {
      padding-top: 41px;
      padding-inline-end: 0px;
      padding-bottom: 0px;
      padding-inline-start: 46px;
      h4.allareakiosk-header {
        font-weight: 700;
        font-size: 17px;
        line-height: 20px;
        color: #000000;
        margin-top: 0px;
        margin-inline-end: auto;
        margin-bottom: 51px;
        margin-inline-start: 0px;
        text-align: center;
      }
      .users-notification {
        font-weight: 400;
        font-size: 16px;
        line-height: 188.5%;
        margin-inline-start: 74px;
        color: #787878;
        .custom-checkbox .custom-control-label::before {
          border: 3px solid #000000 !important;
          border-radius: 3px !important;
          height: 17px !important;
          width: 17px !important;
          background-size: cover !important;
          margin-top: 7px;
          margin-inline-end: 20px !important;
        }
        .custom-control-input:checked ~ .custom-control-label::before {
          background: #000000;
          border-color: #000000;
        }
        .custom-checkbox
          .custom-control-input:checked
          ~ .custom-control-label::after {
          top: 9px;
        }
      }
      .multi-inputs {
        // padding:0px 36px;
        padding-inline-end: 81px;
        margin-inline-start: 41px;
        input#area,
        input#journey,
        input#site {
          background: #f2f2f2 !important;
          &::placeholder {
            font-weight: 700;
            font-size: 16px;
            line-height: 17px;
            letter-spacing: 0.25px;
            color: rgba(0, 0, 0, 0.87);
            opacity: 0.8;
          }
        }
      }
      .actionsline-inside {
        background: #707070;
        height: 1px;
        opacity: 0.15;
        margin-top: 43px;
        margin-bottom: 20px;
        margin-inline-end: 36px !important;
      }
      .actions-btns {
        margin-inline-end: 36px;
        margin-bottom: 21px;
        display: flex;
        align-items: center;
        justify-content: center;
        .submit-btn {
          font-weight: 400 !important;
          font-size: 16px !important;
          line-height: 19px !important;
          text-align: center;
          color: #ffffff !important;
          margin-inline-end: 15px !important;
          width: 111px !important;
          height: 33px !important;
          border-radius: 16px !important;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .cancel-reject {
          margin-inline-start: 15px;
          width: 111px !important;
          height: 33px !important;
          border-radius: 16px !important;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 400 !important;
          font-size: 16px !important;
          line-height: 19px !important;
          text-align: center;
        }
      }
    }
  }
}
// }
</style>
